import { isAuthenticated, getAccessToken } from "../features/auth/services/auth";

export const authFetch = async (input: RequestInfo, init: RequestInit = {}) => {
    const isAuth = await isAuthenticated(); // Refreshes token if needed
    if (!isAuth) throw new Error("User is not authenticated");

    const accessToken = getAccessToken();

    const headers = {
        ...(init.headers || {}),
        Authorization: `Bearer ${accessToken}`,
    };

    return fetch(input, { ...init, headers });
};
